import { render, staticRenderFns } from "./OldDownload.vue?vue&type=template&id=5d91ba98&scoped=true&"
import script from "./OldDownload.vue?vue&type=script&lang=js&"
export * from "./OldDownload.vue?vue&type=script&lang=js&"
import style0 from "./OldDownload.vue?vue&type=style&index=0&id=5d91ba98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d91ba98",
  null
  
)

export default component.exports